module.exports = __webpack_public_path__ + "static/media/authbg1.30ab3231.jpg";